document.addEventListener('DOMContentLoaded', () => {
	const postNavigation = document.querySelector('.post-navigation');
	const h2Elements = document.querySelectorAll('.wp-block-post-content h2');
	const ul = postNavigation?.querySelector('ul');
	const arrowIcon = postNavigation?.querySelector('svg');
	const header = document.querySelector('.header');
	const headerHeight = header?.offsetHeight || 0;

	if (!postNavigation || !ul || !arrowIcon || !h2Elements.length) {
		console.error('Some essential elements are missing.');
		return;
	}

	const toggleNavigation = () => {
		postNavigation.classList.toggle('open');
		ul.style.height = postNavigation.classList.contains('open') ? `${ul.scrollHeight}px` : '0';
		ul.style.opacity = postNavigation.classList.contains('open') ? 1 : 0;
	};

	const handleWindowResize = () => {
		const windowWidth = window.innerWidth;
		if (windowWidth > 1366) {
			postNavigation.classList.add('active');
		} else {
			postNavigation.classList.remove('active');
		}
	};

	arrowIcon.addEventListener('click', toggleNavigation);

	const headersArray = Array.from(h2Elements).map((h2, index) => {
		const id = `header-${index}-${h2.innerText.replace(/\s+/g, '-').toLowerCase()}`;
		h2.id = id;
		return { id, text: h2.innerText };
	});

	headersArray.forEach(({ id, text }) => {
		const li = document.createElement('li');
		const a = document.createElement('a');
		a.className = 'has-special-large-2-font-size';
		a.href = `#${id}`;
		a.textContent = text;
		a.addEventListener('click', handleClickAnchor);
		li.appendChild(a);
		ul.appendChild(li);
	});

	function handleClickAnchor(event) {
		event.preventDefault();
		const targetElement = document.getElementById(this.hash.slice(1));

		if (targetElement) {
			const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
			window.scrollTo({ top: targetPosition, behavior: 'smooth' });
		}
	}

	function handleScroll() {
		let currentActive = null;

		h2Elements.forEach((h2, index) => {
			const rect = h2.getBoundingClientRect();
			if (rect.top <= headerHeight + 50 && rect.top > 0) {
				currentActive = index;
			}
		});

		if (currentActive === null) {
			for (let i = h2Elements.length - 1; i >= 0; i--) {
				if (h2Elements[i].getBoundingClientRect().top < headerHeight) {
					currentActive = i;
					break;
				}
			}

			if (currentActive === null && h2Elements.length) {
				currentActive = 0;
			}
		}

		if (currentActive !== null) {
			const allLi = ul.querySelectorAll('li');
			allLi.forEach(li => li.classList.remove('active'));
			allLi[currentActive].classList.add('active');
		}
	}

	window.addEventListener('scroll', handleScroll);
	window.addEventListener('resize', () => {
		handleWindowResize();
		toggleNavigation();
	});

	handleWindowResize();
});
